/**
 * Trang 404 – giao diện chuyên nghiệp, dẫn người dùng quay lại.
 */
import { Link as RouterLink } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'
import { Home, ArrowBack } from '@mui/icons-material'

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2,
      }}
    >
      <Typography variant="h1" fontWeight={700} sx={{ fontSize: 'clamp(3rem, 10vw, 6rem)', color: 'primary.main', lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h5" fontWeight={600} sx={{ mt: 2 }}>
        Trang không tồn tại
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1, maxWidth: 400 }}>
        Đường dẫn bạn truy cập có thể đã thay đổi hoặc không còn khả dụng.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mt: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button component={RouterLink} to="/" variant="contained" startIcon={<Home />}>
          Về trang chủ
        </Button>
        <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => window.history.back()}>
          Quay lại
        </Button>
      </Box>
    </Box>
  )
}
